import React from 'react';

export default function EmptyProgressReport({ missing, onButtonClick, navigate = window.location.assign }) {
  let buttonText, content, title, handleClick;

  switch (missing) {
    case 'activities':
      title = 'You have no reports yet!';
      buttonText = 'Assign an Activity';
      content = 'In order to access our different reports, you need to assign activities to your students.';
      handleClick = () => navigate('/assign');
      break;

    case 'students':
      title = 'You have no reports yet!';
      buttonText = 'Invite Students';
      content = 'In order to access our different reports, you need to invite your students and assign activities.';
      handleClick = () => navigate('/teachers/classrooms');
      break;

    case 'classrooms':
      title = 'You have no reports yet!';
      buttonText = 'Create a Class';
      content = 'In order to access our different reports, you need to create a class and assign activities to your students.';
      handleClick = () => navigate('/teachers/classrooms?modal=create-a-class');
      break;

    case 'activitiesWithinDateRange':
      title = 'You have no reports in that range.';
      buttonText = 'Reset Date Range';
      content = 'Please select a date range in which you assigned activities or your students worked on them.';
      handleClick = onButtonClick;
      break;

    case 'activitiesForSelectedClassroom':
      title = 'You have no activities for that classroom.';
      buttonText = 'View All Classes';
      content = "Please select a class that has activities, or assign new activities from the 'Assign Activities' page.";
      handleClick = onButtonClick;
      break;

    default:
      title = 'You have no reports yet!';
      buttonText = 'Create a Class';
      content = 'In order to access our different reports, you need to create a class and assign activities to your students.';
      handleClick = () => navigate('/teachers/classrooms?modal=create-a-class');
      break;
  }

  return (
    <div className="empty-progress-report">
      <h2>{title}</h2>
      <p>{content}</p>
      <button
        className="quill-button-archived fun primary contained create-unit featured-button"
        onClick={handleClick}
        type="button"
      >
        {buttonText}
      </button>
      <a href="/teacher-center">Teacher Center</a>
    </div>
  );
}
